(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bad-decisions-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observers = new Map();
    const connect = (scope) => {
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      scope.querySelectorAll('.bad-decisions-home').forEach((home) => {
        if (observers.has(home)) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -24px 0px' });
        home.classList.add('bdh-ready');
        home.querySelectorAll('[data-bd-reveal]').forEach((section) => observer.observe(section));
        observers.set(home, observer);
      });
    };
    const remove = (scope) => {
      scope.querySelectorAll('.bad-decisions-home').forEach((home) => {
        observers.get(home)?.disconnect();
        observers.delete(home);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connect(document), { once: true });
    else connect(document);
    document.addEventListener('shopify:section:load', (event) => connect(event.target));
    document.addEventListener('shopify:section:unload', (event) => remove(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
